document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation
    document.body.addEventListener('click', function(event) {
        if (event.target.classList.contains('ajax-add-to-cart')) {
            var variantId = event.target.getAttribute('data-variant-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Item added to cart:', data);
                // Optionally update cart drawer content here
              $("#mycartdrawer").load(location.href + " #CartDrawer");
            })
            .catch((error) => {
                console.error('Error adding to cart:', error);
            });
        }
         if (event.target.classList.contains('remove-item')) {
            // Get the variantId of the item to be removed
            var variantId = event.target.getAttribute('data-variant-id');
            
            // Fetch the current cart contents to find the correct line number based on the variantId
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    // Find the line number for the item with the given variantId
                    var lineToRemove = null;
                     cart.items.forEach((item, index) => {
                        if (item.variant_id == variantId) {
                            lineToRemove = index + 1; // Line number starts at 1
                        }
                    });

                    // If the line is found, proceed to remove the item
                    if (lineToRemove !== null) {
                        // Send request to remove item from the cart
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                line: lineToRemove,
                                quantity: 0 // Set quantity to 0 to remove the item
                            })
                        })
                        .then(response => response.json())
                        .then(cart => {
                            console.log('Item removed from cart:', cart);
                            // Optionally update the cart drawer after removing the item
                           // updateCartDrawer();
                        })
                        .catch((error) => {
                            console.error('Error removing item from cart:', error);
                        });
                    } else {
                        console.error('Item not found in cart with variantId:', variantId);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching cart data:', error);
                });
        }
    });
});

